import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={17}
        height={17}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.22215 3.56L1.12091 4.66124V19.3285L2.22215 20.4297H21.7779L22.8791 19.3285V4.66124L21.7779 3.56H2.22215ZM3.32339 7.45018V5.76248H20.6766V18.2272H3.32339V9.65266H7.30005V7.45018H3.32339Z"
            fill={props.color ?? "#333030"}
        />
        <path
            d="M14.3 8.55142H22.3"
            stroke={props.color ?? "#333030"}
            strokeWidth={2.20248}
            strokeLinejoin="bevel"
        />
        <path
            d="M9 10.34V9.37C9.23333 9.35667 9.45 9.31333 9.65 9.24C9.85 9.16 10.0267 9.06 10.18 8.94C10.34 8.81333 10.4733 8.67 10.58 8.51C10.6933 8.35 10.7733 8.18 10.82 8H12.59V16.5H10.57V10.34H9Z"
            fill={props.color ?? "#333030"}
        />
        <path
            d="M13.5 16.49L15.18 13.8L13.51 11.41H15.41L16.34 12.74L17.19 11.41H19L17.25 14.04L18.95 16.49H17.07L16.1 15.1L15.27 16.49H13.5Z"
            fill={props.color ?? "#333030"}
        />
    </svg>
);
export default SVGComponent;
